import tinycolor from 'tinycolor2';

const primary = '#006469';
const primarygradient = 'linear-gradient(90deg, #006469, #8ECDC5)';
const secondary = '#F8B7AD';
const error = '#EB5861';
const warning = '#FEB84F';
const success = '#009D9A';
const info = '#10b0c3';

const lightenRate = 7.5;
const darkenRate = 15;

export default {
  palette: {
    primary: {
      main: primary,
      light: tinycolor(primary).lighten(lightenRate).toHexString(),
      dark: tinycolor(primary).darken(darkenRate).toHexString(),
      gradient: primarygradient,
      bg: '#E6F4F3',
      hover: '#D0FFFC',
    },
    secondary: {
      main: secondary,
      light: tinycolor(secondary).lighten(lightenRate).toHexString(),
      dark: tinycolor(secondary).darken(darkenRate).toHexString(),
      contrastText: '#FFFFFF',
    },
    error: {
      main: error,
      light: tinycolor(error).lighten(lightenRate).toHexString(),
      dark: tinycolor(error).darken(darkenRate).toHexString(),
    },
    warning: {
      main: warning,
      light: tinycolor(warning).lighten(lightenRate).toHexString(),
      dark: tinycolor(warning).darken(darkenRate).toHexString(),
    },
    success: {
      main: success,
      light: tinycolor(success).lighten(lightenRate).toHexString(),
      dark: tinycolor(success).darken(darkenRate).toHexString(),
    },
    info: {
      main: info,
      light: tinycolor(info).lighten(lightenRate).toHexString(),
      dark: tinycolor(info).darken(darkenRate).toHexString(),
    },
    disable: {
      main: '#B9B9B9',
      light: '#e7e7e7',
    },
    text: {
      primary: '#405352',
      secondary: '#4A4A4A', //"#6F6363",
      hint: '#C1C1C1',
      header: '#2C504F',

      // primary: "#4A4A4A",
      // secondary: "#6E6E6E",
      // hint: "#B9B9B9"
    },
    background: {
      default: '#E9F0EF',
      // default: "#F6F7FF",
      light: '#F3F5FF',
      green: success,
      header: '#E5F9F6',
      footer: '#F0F6F6',
    },
    border: {
      primary: '#B8CFC3',
    },
  },
  customShadows: {
    widget: '0px 3px 11px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A',
    widgetDark: '0px 3px 18px 0px #4558A3B3, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A',
    widgetWide: '0px 12px 33px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A',
  },
  overrides: {
    MuiOutlinedInput: {
      notchedOutline: {
        border: '1px solid #B8CFC3 !important',
        borderRadius: '2px',
      },
    },
    MuiInputLabel: {
      marginDense: {
        transform: 'translate(14px, 17px) scale(0.7) !important',
      },
      shrink: {
        transform: 'translate(14px, 0px) scale(0.75) !important',
      },
    },
    MuiBackdrop: {
      root: {
        backgroundColor: '#4A4A4A1A',
      },
    },
    MuiModal: {
      root: {
        backgroundColor: 'transparent !important',
      },
    },
    MuiMenu: {
      paper: {
        borderRadius: '2px',
        boxShadow: '0px 3px 11px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A',
      },
    },
    MuiSelect: {
      root: {
        display: 'flex',
      },
      icon: {
        color: '#B9B9B9',
      },
      selectMenu: {
        width: '100%',
      },
    },
    MuiListItem: {
      button: {
        '&:hover, &:focus': {
          backgroundColor: '#F3F5FF',
        },
      },
    },
    MuiTouchRipple: {
      child: {
        backgroundColor: 'white',
      },
    },
    MuiTableRow: {
      root: {
        borderTop: '1px solid rgba(224, 224, 224, .5)',
        height: 56,
        verticalAlign: 'middle',
      },
    },
    MuiTableCell: {
      root: {
        // padding: "4px 40px 4px 24px",
        padding: '4px 20px 4px 24px',
        borderBottom: '1px solid rgba(224, 224, 224, .5)',
      },
      head: {
        fontSize: '1rem',
        color: '#212529',
        fontWeight: 'bold',
      },
      body: {
        fontSize: '0.95rem',
      },
    },
    MUIDataTable: {
      responsiveScrollFullHeight: {
        overflow: 'auto',
        zIndex: 0,
      },
    },
    MuiButton: {
      root: {
        borderRadius: '2px',
      },
      outlined: {
        border: '1px solid #B8CFC3',
      },
    },
    MuiPaper: {
      rounded: {
        borderRadius: '0px',
      },
    },
  },
};
